//#region [IMPORT]

// === THIRD-PARTY ===
import { useEffect, useState } from "react";

// === API ===
import { onTaskUpdate, removeListener } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export function useTaskComplete() {
  //-----------------------------------------------------------------
  
  //#region [VALUES]

  const [ completion_status , setCompletionStatus ] = useState( { accepted: 0, total: 0, percent: 0, is_complete: false } );

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    
    //-----------------------------------------------------------------
    function handleTaskUpdate(data) {
      //-----------------------------------------------------------------
      setCompletionStatus( data.status );
    }

    onTaskUpdate( handleTaskUpdate );

    return () => {
      removeListener( 'TASK-UPDATE', handleTaskUpdate );
    }
  }, [] );

  //#endregion

  return completion_status;
};